//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { request } from "../requests";
import toastr from 'toastr';
import Swal from 'sweetalert2';
import EmailAddresses from "../Widgets/EmailAddresses";
import PhoneNumbers from "../Widgets/PhoneNumbers";
import Multiselect from 'vue-multiselect';
export default {
  name: "EditContact",
  props: {
    context: {
      type: String,
      default: null
    },
    context_id: {
      type: String,
      default: null
    },
    contact: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      redirect_url: '/' + this.context + '/' + this.context_id,
      form: {
        context: this.context,
        context_id: this.context_id,
        prefix: this.contact.prefix,
        id: this.contact.id,
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        email: this.contact.email,
        secondary_email: this.contact.secondary_email || [],
        phone: this.contact.phone || [],
        address: this.contact.address,
        city: this.contact.city,
        state: this.contact.state,
        zip: this.contact.zip,
        job_title: this.contact.job_title,
        department: this.contact.department
      },
      errors: {},
      states: ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC'],
      loading: false
    };
  },

  methods: {
    onSubmit() {
      const toast = Swal.mixin({
        heightAuto: false
      });
      this.loading = true;
      this.errors = {};
      let data = JSON.stringify(this.form);
      return request({
        url: '/forms/contacts/update',
        data
      }).done(response => {
        toast.fire({
          icon: 'success',
          text: response.message,
          title: 'Success',
          position: 'center',
          showCloseButton: false,
          showCancelButton: false,
          showConfirmButton: true
        }).then(() => {
          window.location.replace(this.redirect_url);
        });
      }).catch(this.onFail).always(() => {
        this.loading = false;
      });
    },

    onFail(response) {
      switch (response.status) {
        case 400:
          const responseData = response.responseJSON;

          if (responseData && responseData.errors) {
            this.errors = responseData.errors;
            toastr.error('There are form related errors. Please review and resubmit.', 'Error');
          }

          if (responseData && responseData.message) {
            toast.fire({
              icon: 'error',
              text: responseData.message,
              title: 'Error'
            });
          }

          break;

        default:
          console.debug('The server returned an error: ');
          console.error(response.responseData);
          toastr.error('Something went wrong on our servers. Please try again.', 'Error');
          break;
      }
    }

  },
  components: {
    EmailAddresses,
    PhoneNumbers,
    Multiselect
  }
};